import * as React from 'react';
import Header from 'app/shared/ui/Header';
import { Loader } from 'app/shared/ui/Loader';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { PageStatus, getPageStatus, getCurrentPage } from 'app/shared/pageSystem';

import './Main.css'
import { ErrorInfo } from 'react';
import { CurrentUser } from 'app/shared/model/CurrentUser';
import { getCurrentUser, getCurrentVersion } from 'app/shared/currentUser';

interface MainProps {
    pageStatus: PageStatus
    Page: React.ComponentType<any>|undefined
    user: CurrentUser,
    version: string
}

interface MainPublicProps {
}

function content(props: MainProps) {
    const Page = props.Page || EmptyPage;

    switch(props.pageStatus) {
        case PageStatus.None:
        case PageStatus.Loading:
            return ( 
            <div className="starting-loader">
                <Loader />
                </div>);
        case PageStatus.Found:
            return <div className="ui container main">
                <Page />
            </div>;

        case PageStatus.Error:
        default:
            return ;
    }
}

class EmptyPage extends React.Component {
    render() {
        return <div></div>;
    }
}

// function loadError() {
//     return (
//         <div className="starting-loader">
//             <div className="ui container">
//                 <div className="ui error message">
//                     <div className="header">Unable to start</div>
//                     <p>
//                         Unable to start the application. If the problem persists please contact Help Desk.
//                     </p>
//                     <a className="ui button primary" onClick={e => window.location.reload()}>Retry</a>
//                 </div>
//             </div>
//     </div>);
// }

class Main extends React.Component<MainProps> {
    render() {
        const props = this.props;
        return <div>
            <Header user={props.user} version={props.version} formLoaded={props.pageStatus === PageStatus.Found} />
            {content(props)}
        </div>
    }
}

const mapStateToProps = (state:any, ownProps: MainPublicProps) => {
    const pageStatus = getPageStatus(state);
    let page : React.ComponentType<any>|undefined = undefined;
    switch(pageStatus) {
        case PageStatus.Found:
            page = getCurrentPage(state);
    }

    return {
        pageStatus: pageStatus,
        Page: page,
        user: getCurrentUser(state),
        version: getCurrentVersion(state)
    };
}

const mapDispatchToProps = (dispatch:Dispatch<any>) => {
    return { };
}

const ConnectedMain = connect(mapStateToProps, mapDispatchToProps)(Main);

export default class ErrorOrMain extends React.Component<{}, {hasError: boolean}> {
    constructor(props: {}) {
        super(props);
        this.state = {hasError: false};
    }

    render() {
        // if (this.state.hasError) {
        //     return loadError();
        // }

        return <ConnectedMain />;
    }

    componentDidCatch(error: Error, info: ErrorInfo) {
        this.setState({hasError: true})
    }
}

